import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../../Support/with_presenter';
import {Loader} from '../../../Components/Utils/Loader';
import {ErrorPlaceholder} from '../../../Components/Utils/ErrorPlaceholder';
import {CompareTable} from './Widgets/CompareTable';
import {SplitTable} from './Widgets/SplitTable';
import {AverageCurves} from './Widgets/AverageCurves';
import {Graphs} from './Widgets/Graphs';
import {SplitStrategy} from '../../../../Business/calculateSplitTimes';
import {CompareReportContentPresenter} from './CompareReportContentPresenter';
import {Snippet} from '../../../../Models/Snippet';

interface OwnProps {
    snippets: Snippet[];
    splitStrategy: SplitStrategy;
}

const CompareReportContentComponent: FunctionComponent<OwnProps & PresenterProps<CompareReportContentPresenter>> =
    observer(({splitStrategy, presenter}) => {
        if (presenter.reportDataResult.status === 'error') {
            return <ErrorPlaceholder large className="mt-5" />;
        }

        if (presenter.reportDataResult.status === 'loading') {
            return <Loader className="mt-5" text={presenter.reportDataResult.message || null} />;
        }

        const reportData = presenter.reportDataResult.data;

        return (
            <>
                <CompareTable className="mb-3" reportData={reportData} />
                <SplitTable className="mb-3" splitStrategy={splitStrategy} reportData={reportData} />
                <Graphs className="mb-3" reportData={reportData} />
                <AverageCurves className="mb-3" splitStrategy={splitStrategy} reportData={reportData} />
            </>
        );
    });

export const CompareReportContent = withPresenter<CompareReportContentPresenter, OwnProps>(
    (props, component) => new CompareReportContentPresenter(props.snippets, component.network.strokes),
    CompareReportContentComponent,
);
